import debounce from 'lodash/debounce';
import isEmpty from 'lodash/isEmpty';
import config from '../../../config/app';
import { EXTENSIONS_MODULE, PRODUCTION } from './constants';
import history from '../../../utils/history';

export const getQueryParams = params => {
  if (!params) return '';
  var queryParams = '';
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const value = Array.isArray(params[key])
        ? JSON.stringify(params[key])
        : params[key];
      queryParams = !queryParams
        ? `${key}=${value}`
        : `${queryParams}&${key}=${value}`;
    }
  }
  return queryParams;
};

export const debounceHandler = (fn, timeout) => debounce(fn, timeout);

export const formatMessageHandler = ({
  formatMessage,
  id,
  fallback,
  state,
}) => {
  try {
    // if value is passed -> {xNumber} in message itself
    if (state) {
      return formatMessage(id, state);
    }

    return formatMessage(id);
  } catch (err) {
    // if helperTextContainsValues to be added to string
    if (!isEmpty(state)) {
      Object.keys(state).forEach(key => {
        fallback = fallback.replace(`{${key}}`, state[key]);
      });
    }
    return fallback;
  }
};

export const isExtensionsModule = () =>
  window.location.pathname?.indexOf(EXTENSIONS_MODULE) > -1;

export const moduleRedirector = (moduleUrl) => {
  const isProd = process.env.NODE_ENV === PRODUCTION;

  if (!isProd) {
    window.location.href = config.development.dashboard_url;
    return;
  }

  window.location.href = moduleUrl || config.production.dashboard_url;
};

/**
 * Extracts and formats username from a base64-encoded email identifier
 * @param {string} base64Identifier - Base64 encoded email string
 * @returns {string} - Formatted username
 */
export const extractUsernameFromIdentifier = (base64Identifier) => {
  if (!base64Identifier) {
    return 'User';
  }

  try {
    // Decode base64 identifier to get the email
    const decodedEmail = atob(base64Identifier);
    
    // Extract username from email: split at @, then at ., take first part and capitalize
    const emailParts = decodedEmail.split('@');
    if (emailParts.length > 1) {
      const domainParts = emailParts[0].split('.');
      const firstName = domainParts[0];
      // Capitalize first letter and make rest lowercase
      return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    }
    
    return decodedEmail;
  } catch (error) {
    console.error('Error decoding identifier:', error);
    return 'User';
  }
};

export const generateLoginMarketingMFEProps = () => {
  const host = window.location.host;
  const isUAT = /(dev|nightly|staging|localhost)/i.test(host);

  const UAT_CONFIG = {
    url: 'https://vulcan.global.nightly.intouch.capillarytech.com/login-marketing/ui',
    scope: 'crm_nightly_new_0_loginMarketingPage_MFE',
    module: './LoginMarketing',
  };

  const PROD_CONFIG = {
    url: 'https://vulcan.global.apac.intouch.capillarytech.com/login-marketing/ui',
    scope: 'incrm_0_loginMarketingPage_MFE',
    module: './LoginMarketing',
  };

  return isUAT ? UAT_CONFIG : PROD_CONFIG;
};

